// extracted by mini-css-extract-plugin
module.exports = {"pane":"pane__lpmwo","thumbnail":"thumbnail__1IM8d","text":"text__X9RIm","main":"main__CjMer","sub":"sub__3MTFb","button-toolbar":"button-toolbar__3ZRgM"};